import { createSelector } from '@opengov/compose-app/reselect';

import { summaryTableSelector } from './state';

export const selectSummaryTableData = createSelector(summaryTableSelector, (state) => state.data);

export const selectSummaryTableReportConfiguration = createSelector(
  summaryTableSelector,
  (state) => state.reportConfiguration
);

export const selectSummaryTableColumns = createSelector(summaryTableSelector, (state) => state.columns);
